{
  "pages": {
    "subsidiary": {
      "title": "Subsidiary Organization"
    }
  },
  "components": {
    "subsidiaryTable": {
      "columns": {
        "name": "Name",
        "spend": "Spend",
        "savingsApproved": "Savings Approved",
        "savingsIdentified": "Savings Identified"
      },
      "filters": {
        "spendCategory": "Spend Category"
      }
    },
    "noData": {
      "title": "No subsidiary organizations found",
      "description": "No subsidiary organizations found"
    },
    "noFilteredData": {
      "title": "No subsidiary organizations found",
      "description": "No subsidiary organizations found with the current filters"
    }
  }
}
